<template>
    <span v-html="purifiedHtml" class="rich-text"></span>
</template>

<script>
import DOMPurify from 'dompurify'

export default {
    props: ['html', 'highlight'],
    mounted() {
        this.$el.addEventListener('click', (ev) => {
            let stack = 10
            let parentAnchor = ev.target
            while (parentAnchor && stack > 0) {
                stack -= 1
                if (parentAnchor.tagName == 'A') {
                    if (parentAnchor.hasAttribute('modal')) {
                        return
                    }

                    ev.preventDefault()
                    ev.stopPropagation()

                    window.open(parentAnchor.getAttribute('href'), '_blank')
                    return
                }
                parentAnchor = parentAnchor.parentElement
            }
        })
    },
    computed: {
        purifiedHtml() {
            let html = this.html
            let match = html.match(/([^\"]|^)(https?:\/\/[^\s\<\>\"]+)([^\"]|$)/)

            if (match) {
                let url = match[2]

                let anchor = `<a href="${url}" reflinks="false" target="_blank">${
                    url.length > 30 ? url.substr(0, 30) + '...' : url
                }</a>`

                html = html.replace(url, anchor, html)
            }

            let result = DOMPurify.sanitize(html, {
                ALLOWED_TAGS: [
                    'b',
                    'i',
                    'strong',
                    'div',
                    'p',
                    'img',
                    'span',
                    'br',
                    'teclia-trix-attachment',
                    'table',
                    'tr',
                    'td',
                    'a',
                    'blockquote',
                    'ul',
                    'ol',
                    'li',
                    'h1',
                ],
                ADD_ATTR: ['target', 'reflinks', 'modal'],
            })

            if (this.highlight) {
                let words = this.highlight.trim().split(' ')
                words.forEach((word) => {
                    word = word.trim().replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
                    let regex = new RegExp('(' + word + ')', 'gi')
                    result = result.replace(regex, '<span class="bg-yellow-200">$1</span>')
                })
            }

            return result
        },
    },
}
</script>